import React, { useState, useEffect } from "react";
import { NavbarMenu } from "../../data/navData";
import { CiSearch } from "react-icons/ci";
import { SiHiltonhotelsandresorts } from "react-icons/si";
import { PiShoppingCartThin } from "react-icons/pi";
import { MdMenu } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import HamburgerMenu from "./hamburgerMenu";
import { fetchCurrentUser } from "../../utils/auth";

export default function NavigationBar() {
  const [open, setOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const checkUser = async () => {
      const user = await fetchCurrentUser();
      if (!user.loggedIn) {
        setCurrentUser(null);
      } else {
        setCurrentUser(user);
      }
    };
    checkUser();
  }, []);
  const navigate = useNavigate();
  // Detect scrolling to apply a border and shadow
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up event listener
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  function getInitials(name) {
    if (!name) return "";

    const parts = name.trim().split(/\s+/); // split by whitespace
    if (parts.length === 1) {
      // Single name
      return parts[0][0].toUpperCase();
    }

    // Two or more parts — take first letter of first 2 parts
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto"; // Cleanup on unmount
    };
  }, [open]);

  return (
    <div>
      <nav
        className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
          isScrolled
            ? "bg-white border-b-2 border-gray-300 shadow-lg"
            : "bg-transparent"
        }`}
      >
        <div className="container flex justify-between items-center py-4 px-4 md:px-16">
          {/* Logo + Name Section */}
          <div className="flex items-center gap-4">
            <img
              src="../assets/logo.jpg"
              alt="logo"
              className="w-16 h-16 md:w-20 md:h-20"
            />
            <div className="hidden md:flex flex-col text-md md:text-2xl font-bold uppercase">
              <p>Room Booking Penukonda</p>
              <p className="text-orange-400">Baba Fakruddin</p>
            </div>

            <div className="flex md:hidden flex-col text-lg font-bold uppercase ">
              <p className="text-orange-400">Baba Fakhruddin</p>
              <p>Rooms</p>
            </div>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-6 mr-48 text-gray-600">
            <ul className="flex items-center gap-6">
              {NavbarMenu.map((item) => (
                <li key={item.id}>
                  <a
                    href={item.link}
                    className="inline-block py-1 px-3 hover:text-orange-300 font-semibold"
                  >
                    {item.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Right-side Buttons (Profile/Login + Hamburger) */}
          <div className="flex items-center gap-4">
            {currentUser &&
            currentUser.loggedIn &&
            currentUser.role_id === 1 ? (
              <button
                title="User Profile"
                onClick={() =>
                  navigate("/profile", { state: { user: currentUser } })
                }
                className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-orange-700 text-white font-semibold flex items-center justify-center text-lg"
              >
                {getInitials(currentUser.username)}
              </button>
            ) : (
              <button
                onClick={() => navigate("/login")}
                className="text-sm md:text-base hover:bg-orange-300 text-orange-300 font-semibold hover:text-white rounded-md border-2 border-orange-300 px-4 py-1 md:px-6 md:py-2 transition"
              >
                Login
              </button>
            )}

            {/* Mobile Hamburger */}
            <div className="md:hidden" onClick={() => setOpen(!open)}>
              <MdMenu className="text-3xl" />
            </div>
          </div>
        </div>
        <div className="w-full bg-yellow-50 border-l-4 border-yellow-400 text-yellow-800 py-2 px-4 text-center font-medium text-sm rounded-b shadow-sm ">
          ⚠️ Page Under Development — Please do not make any bookings yet!
        </div>
      </nav>

      {/* Mobile Sidebar */}
      <HamburgerMenu open={open} />
    </div>
  );
}
